export type CurrentBreakpoint =
  | 'small'
  | 'mobile'
  | 'tablet'
  | 'laptop'
  | 'desktop';

export const getCurrentBreakpoint =
  (small: boolean, mobile: boolean, tablet: boolean, laptop: boolean, desktop: boolean): CurrentBreakpoint => {

    if (small) {
      return 'small';
    }
    if (mobile) {
      return 'mobile';
    }
    if (tablet) {
      return 'tablet';
    }
    if (laptop) {
      return 'laptop';
    }
    if (desktop) {
      return 'desktop';
    }

    return 'small';
  };
